module.exports = __webpack_public_path__ + "assets/img/btn-view-72886ac8.png";